import WebLayout from './PopupLayout.web';
import MobileLayout from './PopupLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
